import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { authAxios } from "./axios";

export const useChangeOrganisation = () => {
  const [state, execute, cancel] = authAxios({
    url: "/changeOrganisation/:id",
    method: "GET",
    withCredentials: true,
  });

  const callback = useCallback(
    (id: ObjectId) => {
      return execute({
        url: `/changeOrganisation/${id}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
